import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contact } from './contact';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }

  // Add Contact
  addContact(contact: any): Observable<any> {
    return this.http.post<any>(`/contacts`, contact);
  }

  // Update Contact
  updateContact(contact: any): Observable<any> {
    return this.http.put<any>(`/contacts/${contact.id}`, contact);
  }

  // Delete Contact
  deleteContact(contactId: string): Observable<any> {
    return this.http.delete<any>(`/contacts/${contactId}`);
  }

  // Get Contacts
  getContacts(params: any): Observable<{ contacts: Contact[], count: number }> {
    return this.http.get<{ contacts: Contact[], count: number }>(`/contacts`, {
      params: params
    });
  }

  // Get Distinct Column Values
  getDistinctColumnValues(params: any): Observable<string[]> {
    return this.http.get<string[]>(`/contacts/distinctColumnValues`, {
      params: params
    });
  }
}
